<template>
  <div class="relative">
    <button 
      @click="toggleDropdown" 
      class="flex items-center space-x-2 text-white hover:text-blue-200 transition-colors"
    >
      <span>{{ currentLanguage }}</span>
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
    </button>
    
    <div 
      v-if="isOpen" 
      class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50"
    >
      <button 
        v-for="(name, locale) in languages" 
        :key="locale"
        @click="changeLanguage(locale)"
        class="w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 transition-colors"
      >
        {{ name }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()
const isOpen = ref(false)

const languages = {
  en: 'English',
  zh: '中文',
  ja: '日本語',
  ko: '한국어'
}

const currentLanguage = computed(() => languages[locale.value])

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const changeLanguage = (newLocale) => {
  locale.value = newLocale
  isOpen.value = false
}

const handleClickOutside = (event) => {
  if (!event.target.closest('.relative')) {
    isOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script> 